import React from "react";

const Header = () => {
  return (
    <header className="py-8 ">
      <div className="container mx-auto">
        <div className="flex justify-between items-center">
          <h1 className="bg-gradient-to-r from-gray-200 via-gray-400 to-gray-600 bg-clip-text text-transparent">
            Delvin "Zomo" Reyes{" "}
          </h1>
        </div>
      </div>
    </header>
  );
};

export default Header;
